import React from 'react'
import {
    Form,
  Input,
  TextArea,
  Toast,
  Button,ImageUploader,Ellipsis,List,Picker,Modal,Dialog,NavBar
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, SetOutline,RightOutline } from 'antd-mobile-icons'
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { useNavigate } from 'react-router-dom';

import '../Seting/index.css'

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};

class Index extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    componentDidMount() {


    }


    render() {


        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>

                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/my', { replace: true, state: { from: 'home' } }); // 传递状态
                }}>
                    设置
                </NavBar>

                <div style={{
                    height: "85%", backgroundColor: "rgb(227 227 227)"
                }}>

                    <div className="setting" style={{ paddingTop: "10px" }}>
                        <List mode='card' header=''>
                            <List.Item onClick={() => {
                                this.props.navigate('/userEdit', { replace: true, state: { from: 'home' } }); // 传递状态
                            }}>
                                账号设置
                            </List.Item>
                            <List.Item onClick={() => {
                                this.props.navigate('/postsSeting', { replace: true, state: { from: 'home' } }); // 传递状态
                            }}>跟帖设置</List.Item>
                            {/* <List.Item onClick={() => {
                                Toast.show({
                                    content: '暂未开放，敬请期待！'
                                })
                            }}>关联讣告</List.Item> */}
                        </List>
                    </div>

                </div>


                <BottomMenu position="absolute" selectKey="my" />

            </div>
        )
    }
}

// export default Index 
export default withNavigate(Index);